var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"white-box"},[_c('input',{staticClass:"dropify",attrs:{"type":"file","id":"input-file-max-fs","data-max-file-size":"5M","data-allowed-file-extensions":"jpg png bmp"},on:{"change":_vm.upload}})])}
var staticRenderFns = []

export { render, staticRenderFns }